<template>
  <div class="duration-wrapper">
    <div class="checkbox-row">
      <v-checkbox
        v-model="checked"
        label="Ja"
        color="#33bbff"
        value="1"
        :disabled="checked == '1'"
        hide-details
        @change="$emit('input', '1')"
        :readonly="readonly"
      ></v-checkbox>

      <v-checkbox
        v-model="checked"
        label="Nein"
        color="#33bbff"
        value="0"
        :disabled="checked == '0'"
        @change="$emit('input', '0')"
        hide-details
        :readonly="readonly"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "readonly"],
  data() {
    return {
      checked: this.value ? this.value : "0",
    };
  },
  methods: {},
  mounted() {
  },
  computed: {},
};
</script>

<style>
</style>